module.exports = __webpack_public_path__ + "static/media/400150_02.4b7d8092.png";